import { Address, enumObject, EnumObjectValue } from '@app/base';
import { ConsentFragment, ConsentListItemFragment } from './graphql';
import { Patient } from './patientsTypes';
import { Organization } from './organizationTypes';

export const ConsentSignatureType = enumObject('ConsentSignatureType', ['CHECKBOX', 'SIGNATURE'] as const);

export function requiresSignature(consent: { signatureType?: string | null } | undefined): boolean {
  return consent?.signatureType === 'SIGNATURE' || consent?.signatureType === 'CHECKBOX';
}

export const ConsentStatus = enumObject('ConsentStatus', ['SIGNED', 'NOT_SIGNED'] as const);

export const CONSENT_SIGNER_ROLE_VALUES = [
  'PATIENT',
  'NEXT_OF_KIN',
  'CARER_OF_PATIENT',
] as const;

export const ConsentSignerRole = enumObject('ConsentSignerRole', CONSENT_SIGNER_ROLE_VALUES);
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ConsentSignatureType = EnumObjectValue<typeof ConsentSignatureType>;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ConsentStatus = EnumObjectValue<typeof ConsentStatus>;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ConsentSignerRole = EnumObjectValue<typeof ConsentSignerRole>;

export interface ConsentSignerDetails {
  role: ConsentSignerRole;
  relation?: string | null;
  name: string;
  address: Address;
}

export const CONSENT_PREFIX_PATIENT = 'patient://';
export const CONSENT_PREFIX_ENCOUNTER = 'encounter://';

export type ConsentListItem = ConsentListItemFragment;
export type Consent = ConsentFragment & { signerDetails?: ConsentSignerDetails | null };

export type ConsentExportData = {
  consent: Consent;
  organization: Organization;
  patient: Patient;
};

export interface CreateConsentRequest {
  assigneeId: string;
  templateId: string;
  referenceId: string;
}

export interface UpdateConsentRequest {
  id: string;
  data: string;
  version: string;
}

export interface SignConsentSignerDetailsRequest {
  role: ConsentSignerRole;
  name?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  townCity?: string | null;
  county?: string | null;
  country?: string | null;
  postcode?: string | null;
}

export interface SignConsentRequest {
  id: string;
  signature: string | null;
  version: string;
  signerDetails?: SignConsentSignerDetailsRequest | null;
}
